import { Clickable } from '@carvana/merch-components';
import { useContext } from 'react';
import { useIsMobile } from '~/context/common/DeviceContext';
import ModalContext from '~/context/vdp/ModalContext';
import type { RecommendedVehicle } from '~/contracts/common';
import type { EarliestDate } from '~/contracts/vdp';
import getAsSoonAsText from '~/utilities/date/getAsSoonAsText';
import { InnerWrapper, Link, Text, Wrapper } from './DeliveryHeader.styles';
import useGetEarliestDate from '../hooks/useGetEarliestDate';
import SimilarVehiclesModal from '../SimilarVehiclesModal';

const FoundVehicles = ({
  className,
  deliveryDate
}: {
  className?: string;
  deliveryDate?: string;
}) => {
  const isMobile = useIsMobile();

  return deliveryDate ? (
    <Text className={className}>
      {isMobile
        ? 'These vehicles arrive sooner than'
        : 'We found similar vehicles that arrive sooner than'}{' '}
      {deliveryDate}.
    </Text>
  ) : null;
};

type OwnProps = {
  vehicles: RecommendedVehicle[];
};

export const DeliveryHeader = ({ vehicles }: OwnProps) => {
  const earliestDate: EarliestDate = useGetEarliestDate();

  const deliveryDate = getAsSoonAsText(
    earliestDate.asSoonAsText,
    earliestDate.earliestDate
  );
  const { setSimilarVehiclesModal } = useContext(ModalContext);
  const isMobile = useIsMobile();

  return (
    <Wrapper className={isMobile ? 'items-center' : ''}>
      <InnerWrapper>
        <p className="mx-auto m:mx-0 m:w-3/4">
          Need it Sooner?{' '}
          <FoundVehicles
            className="hidden m:inline-block"
            deliveryDate={deliveryDate}
          />
        </p>
        {vehicles.length > 0 && !isMobile && (
          <Clickable
            data-analytics-id="Pickup And Delivery - View More"
            data-qa="Pickup And Delivery - View More"
            onClick={() => {
              setSimilarVehiclesModal(true);
            }}
            element={Link}
          >
            View More
          </Clickable>
        )}
        <SimilarVehiclesModal vehicles={vehicles} earliestDate={earliestDate} />
      </InnerWrapper>
      <FoundVehicles
        className="inline text-center m:hidden"
        deliveryDate={deliveryDate}
      />
      {vehicles.length > 0 && isMobile && (
        <Clickable
          data-analytics-id="Pickup And Delivery - View More"
          data-qa="Pickup And Delivery - View More"
          onClick={() => {
            setSimilarVehiclesModal(true);
          }}
          element={Link}
        >
          View More
        </Clickable>
      )}
    </Wrapper>
  );
};

export default DeliveryHeader;
